import * as PouchDB from 'pouchdb';
import PouchDBFind from 'pouchdb-find';
import PouchDBAuthentication from 'pouchdb-authentication';
PouchDB.default.plugin(PouchDBFind)
PouchDB.default.plugin(PouchDBAuthentication)

var URL_DATABASE = process.env.REACT_APP_DB_URL

class Database {
    local_database!: PouchDB.Database<{}>;;
    remote_database!: PouchDB.Database<{}>;

    constructor(db_name, local = true, remote = true) {
        if (local) { this.local_database = new PouchDB.default(db_name) }
        if (remote && navigator.onLine) {
            this.remote_database = new PouchDB.default(URL_DATABASE + "/" + db_name)
        }
    }

    pushToRemote = async () => {
        this.local_database.replicate.to(this.remote_database)
    }

    fetchFromRemote = async () => {
        this.local_database.replicate.from(this.remote_database
        ).on('change', function (info) {
        // handle change
        }).on('complete', function (info) {
        // handle 
        }).on('error', function (err) {
        // handle error
        });
    }
}

export { Database }

export const checkConnectivity = async () => {
    var db = new PouchDB.default('user')
    try {
        await db.info();
        return true
    } catch (err) {
        return false
    }
}


export const deletePouchDB = async () => {
    const dbs = await window.indexedDB.databases();
    dbs.forEach(db => {
        if (db.name?.includes("_pouch_")) {
            window.indexedDB.deleteDatabase(db.name)
        }
    })
}


// store username and user's roles for offline needs
export const storeUserMetadata = async (response) => {
    
    var db = new PouchDB.default('user')
    await db.destroy().then(async function () {
        db = new PouchDB.default('user')
        response["_id"] = String((new Date()).getTime());
        await db.put(response)
    })
}

// log out from the app
export const removeCacheAndLogOut = async () => {
    await deletePouchDB()
    var rdb = new PouchDB.default(URL_DATABASE, {skip_setup: true})
    await rdb.logOut()
}



export const getUsername = async () => {
    var username

    if (navigator.onLine) {
        let db = new PouchDB.default(URL_DATABASE, {skip_setup: true})
        username = (await db.getSession()).userCtx.name
    } else {

        let db = new PouchDB.default('user')
        let user = (await db.allDocs({
            include_docs: true,
            attachments: true,
        })).rows[0].doc as any

        username = user.name
    }

    return username
}


export const getSessionStatus = ({ childToParent }) => {
    let db = new PouchDB.default(URL_DATABASE)

    db.getSession(function (err, response) {
        if (err) {
          // network error
          db = new PouchDB.default('user')
          db.allDocs({
              include_docs: true,
              attachments: true,
          }).then(result => {
              if (result.rows[0]) {
                  childToParent({
                      "isConnected": true,
                      "roles": (result.rows[0].doc as any).roles,
                      "isOnline": false
                  })
              } else {
                  childToParent({ "IsConnected": false, "roles": [], "isOnline": false})
              }
          })

        } else if (!response) {
            // lack of response
            childToParent({ "IsConnected": false, "roles": [], "isOnline": false})

        } else if (!response.userCtx.name) {
            // nobody's logged in
            childToParent({ "IsConnected": false, "roles": [], "isOnline": false })

        } else {
            childToParent({
                "isConnected": true,
                "roles": response.userCtx.roles,
                "isOnline": true
            })
        }
      });
}
